(() => {
  'use strict';
  function prepareGalleries() {
    document.querySelectorAll('[data-testid="wam-gallery"]').forEach(gallery => {
      const scrollable = ['auto', 'scroll'].includes(getComputedStyle(gallery).overflowX) && gallery.scrollWidth > gallery.clientWidth;
      gallery.tabIndex = scrollable ? 0 : -1;
    });
  }
  function prepareContent(root) {
    prepareGalleries();
    root.querySelectorAll('fieldset').forEach(fieldset => {
      const radios = [...fieldset.querySelectorAll('input[type="radio"][name="Size"]')];
      if (radios.length < 5 || !radios.every(input => Number.isFinite(parseFloat(input.value)))) return;
      if (fieldset.dataset.wamOrdered === 'true') return;
      const selected = radios.find(input => input.checked);
      const pairs = radios.map(input => ({
        input,
        label: [...fieldset.querySelectorAll('label')].find(label => label.htmlFor === input.id)
      }));
      if (pairs.some(pair => !pair.label)) return;
      pairs.sort((a, b) => parseFloat(a.input.value) - parseFloat(b.input.value));
      pairs.forEach(({ input, label }) => { label.style.removeProperty('order'); fieldset.append(input, label); });
      if (selected) selected.checked = true;
      fieldset.classList.add('wam-beden-sirali');
      fieldset.dataset.wamOrdered = 'true';
    });
    root.querySelectorAll('video > img:not([alt])').forEach(image => { image.alt = ''; });
    root.querySelectorAll('.post-content table').forEach(table => {
      if (table.parentElement.classList.contains('wam-table-scroll')) return;
      const parent = table.parentElement;
      if (getComputedStyle(parent).overflowX === 'auto') {
        parent.classList.add('wam-table-scroll');
        parent.tabIndex = 0;
        parent.setAttribute('role', 'region');
        parent.setAttribute('aria-label', 'Table');
      } else {
        const wrapper = document.createElement('div');
        wrapper.className = 'wam-table-scroll';
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', 'Table');
        table.before(wrapper);
        wrapper.append(table);
      }
    });
  }
  const prepare = () => prepareContent(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare, { once: true });
  else prepare();
  window.addEventListener('resize', prepareGalleries);
  document.addEventListener('wam:results-updated', prepare);
  document.addEventListener('quick-view:open', prepare);
  document.addEventListener('shopify:section:load', prepare);
})();
/* Müşteri deneyimi H7 (3 Kas 2026, Musteri-Deneyimi-Tum-Siteler): sohbet düğmesi kaydırırken saklanır; durunca korunan öğeyi örtüyorsa saklı kalır. DK dk-tema-kusur deseni. */
(function () {
  var html = document.documentElement, zaman = 0, zaman2 = 0;
  var korunan = '.wam-fs, .wam-return-summary, .variations label, .single_add_to_cart_button, .shopify-payment-button__button';
  html.classList.add('mx-yuzen-izle');
  function ortuyor(e) {
    // Saklama yalnız görünürlükle yapılır; kutu yerinde kalır, ölçüm saklıyken de doğru.
    var a = e.getBoundingClientRect();
    if (!a.width) return false;
    return [].some.call(document.querySelectorAll(korunan), function (k) {
      // Kapalı <details> içeriği görünmez ama kutusu ölçülür: örtme sayılmaz.
      if (k.closest('details:not([open])')) return false;
      var r = k.getBoundingClientRect();
      // Kapanırken yerinde kalan kap (visibility, opacity ya da sıfır yükseklik) örtme sayılmaz.
      var st = getComputedStyle(k);
      if (!r.height || st.visibility === 'hidden' || st.opacity === '0') return false;
      // Ata kap opacity ile kapanırsa çocuğun kendi değeri 1 kalır; destekleyen tarayıcıda zincir okunur.
      if (k.checkVisibility && !k.checkVisibility({ opacityProperty: true, visibilityProperty: true })) return false;
      return r.width && r.left < a.right && r.right > a.left && r.top < a.bottom && r.bottom > a.top;
    });
  }
  function karar(kaydiriyor) {
    var e = document.getElementById('dkc-btn'), panel = document.getElementById('dkc-panel');
    // Klavye odağı düğmedeyken saklanmaz: visibility hidden odağı düşürür.
    var sakla = !!e && !(panel && panel.classList.contains('open')) && !e.contains(document.activeElement) && (kaydiriyor || ortuyor(e));
    html.classList.toggle('mx-cekik-sohbet', sakla);
  }
  window.addEventListener('scroll', function () {
    karar(true);
    clearTimeout(zaman); clearTimeout(zaman2);
    zaman = setTimeout(function () { karar(false); }, 150);
    // Kaydırma bitince yüklenen görseller yerleşimi kaydırabilir: karar bir kez daha verilir.
    zaman2 = setTimeout(function () { karar(false); }, 750);
  }, { passive: true });
  window.addEventListener('resize', function () { karar(false); });
  // Klavyeyle düğmeye gelen kullanıcı için saklama kalkar; saklama yalnız görünümdedir, sekme sırasından çıkarmaz.
  document.addEventListener('focusin', function () { karar(false); });
  document.addEventListener('toggle', function (ev) { if (ev.target && ev.target.tagName === 'DETAILS') karar(false); }, true);
  function sonra() { karar(false); setTimeout(function () { karar(false); }, 400); setTimeout(function () { karar(false); }, 2500); }
  // Sohbet düğmesi geç yüklenir: ilk karar düğme gelince ve yerleşim oturunca yinelenir.
  var ilk = new MutationObserver(function () { if (document.getElementById('dkc-btn')) { ilk.disconnect(); sonra(); } });
  ilk.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('load', sonra);
  // Kaydırılamayan sayfada korunan öğe kapanırsa tık sonrası karar yinelenir.
  function sonraTik() { setTimeout(function () { karar(false); }, 400); }
  // Yakalama evresi: kapatma düğmesi stopPropagation yapsa da karar yinelenir; ESC ile kapanış da aynı yolda.
  document.addEventListener('click', sonraTik, true);
  document.addEventListener('keyup', function (ev) { if (ev.key === 'Escape') sonraTik(); });
  karar(false);
})();
